"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fileUpload_1 = __importDefault(require("./fileUpload"));
const fields = {
    FileUploadField: fileUpload_1.default
};
exports.default = fields;
//# sourceMappingURL=index.js.map